module.exports = __webpack_public_path__ + "static/media/research-project.c953c876.svg";